<template>


  <div class="container container-tabs">

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>





      <div class="handle-box">

        <el-row class="head-search">
          <el-col :span="8">
            <span class="title">地点名称:</span>
            <!-- 搜索司机名称-->
            <el-input v-model="search_data.name" placeholder="请输入地点名称 " class="handle-input mr10" @keyup.enter.native="searchCoordinates"></el-input>
          </el-col>




        </el-row>

      </div>

      <div>

        <el-button type="primary" icon="el-icon-search" @click="searchCoordinates">搜索</el-button>
        <el-button @click="add_isShow=!add_isShow">添加</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>

    </el-tabs>


    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" prop="coordinates_code"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">

            <div class="more-style">
              <el-form-item label="开始展示日期:">
                <span>{{ props.row.start_time.Ymd }}</span>
              </el-form-item>
              <el-form-item label="结束展示日期:">
                <span>{{ props.row.end_time.Ymd }}</span>
              </el-form-item>
            </div>

            <div class="more-style">
              <el-form-item label="经度:">
                <span>{{ props.row.lng }}</span>
              </el-form-item>
              <el-form-item label="纬度:">
                <span>{{ props.row.lat }}</span>
              </el-form-item>
            </div>

            <div class="more-style" v-for="(item, index) in props.row.synchronization" :key="index">
              <el-form-item label="开始时间:">
                <span>{{ item.time_start }}</span>
              </el-form-item>
              <el-form-item label="结束时间:">
                <span>{{ item.time_end }}</span>
              </el-form-item>
            </div>

            <div>
              <el-form-item label="备注:">
                <span>{{ props.row.remarks }}</span>
              </el-form-item>
            </div>


          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" min-width="80">
      </el-table-column>

      <el-table-column prop="name" label="地点名称" min-width="200">

      </el-table-column>



      <el-table-column label="门店照片">

        <template scope="scope">
          <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;" :src="scope.row.logo_img.url"></el-image>

        </template>
      </el-table-column>

      <el-table-column prop="top.alias" label="置顶">
      </el-table-column>

      <el-table-column prop="weights" label="权重">
      </el-table-column>

      <el-table-column label="管理状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="edit_isShow = !edit_isShow; coordinates_code_children = scope.row.coordinates_code; ">

            编辑



          </el-button>

        </template>
      </el-table-column>
    </el-table>


    <!-- 批量删除按钮 -->
    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
      style="margin-top: 20px;">批量删除</el-button>

    <!-- 分页组件 -->
    <div class="pagination">

      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加组件 -->
    <addCoordinates :isShow="add_isShow" @onSubmit="coordinates"></addCoordinates>

    <!-- 编辑组件 -->
    <editCoordinates :isShow="edit_isShow" :data="coordinates_code_children" @onSubmit="coordinates"></editCoordinates>


  </div>


</template>

<script>
  var _this;
  import addCoordinates from './addCoordinates.vue';
  import editCoordinates from './editCoordinates.vue';

  import bus from '../../common/bus.js';

  export default {
    components: {
      addCoordinates,
      editCoordinates,

    },
    data() {
      return {

        // 选项卡默认选中项
        activeName: 'all',

        // 传入子组件的数据
        coordinates_code_children: '',


        // 批量删除
        delCoordinatesSubmit_data: {
          coordinates_code_array: []
        },
        delCoordinatesSubmit_rules: {
          coordinates_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },

        // 抽屉开关按钮
        edit_isShow: false,
        add_isShow: false,



        // 下拉搜索管理状态
        value_status_array: [],

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          name: '',
          status: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;

      _this.coordinates();

    },

    methods: {
      searchCoordinates(){
        _this.search_data.page = 1;
        _this.coordinates();
      },
      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.coordinates();

      },


      // 搜索推荐地址列表
      coordinates() {
        _this.$post(
            "/coordinates/coordinatesLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;


            // _this.val_sex_array = _this.tableData[0].sex.select_array;
            _this.value_status_array = _this.tableData[0].status.select_array;

          }).catch((err) => {

          })
      },

      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.coordinates();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].coordinates_code);

        }
        _this.delCoordinatesSubmit_data.coordinates_code_array = datalist;
      },

      // 批量删除
      deleteData() {

        if (_this.delCoordinatesSubmit_data.coordinates_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delCoordinatesSubmit_data.coordinates_code_array = JSON.stringify(_this.delCoordinatesSubmit_data
            .coordinates_code_array);

          _this.$post(
              "/coordinates/deleteCoordinatesSubmit",
              _this.delCoordinatesSubmit_data,
              _this.delCoordinatesSubmit_rules
            )
            .then(res => {

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.coordinates();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message.info('已取消删除');

        });


      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },


    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    max-width: 150px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>